import React, { useState,useEffect } from 'react'
import { useFormInputValidation } from "react-form-input-validation";
import { useNavigate,Link } from 'react-router-dom';
import {signIn} from '../../api/apiHandler'
import { loginRedirectCallWithDataStore } from '../Common/RedirectPathMange';

export default function SignIn() {
    const navigate=useNavigate()

const [fields, errors, form] = useFormInputValidation({
    email: "",
    password: "",
}, {
    email: "required|email",
    password: "required"
});

const onSubmit = async (event) => {
    event.preventDefault();
    const isValid = await form.validate(event);
    if (isValid) {
      loginAPI()
    }
  }

  // Login API calling 
  const loginAPI=()=>{
    signIn({"email":fields.email,"password":fields.password}).then((resposnse)=>{
        if(resposnse.data.code==1){
            loginRedirectCallWithDataStore(resposnse.data.data)
        }else{
            
        }
    }); 
  }

return (
<div className="authentication">
    <div className="card">
        <div className="body">
            <div className="row">
                <div className="col-lg-12">
                    <div className="header slideDown">
                        <div className="logo"><img src={process.env.PUBLIC_URL+"/assets/images/logo-2.png"} alt="Nexa"/></div>
                        <h1>Donor Panel</h1>
                    </div>                        
                </div>
                <form className="col-lg-12" id="form_validation" noValidate autoComplete="off" onSubmit={onSubmit} method="" action='#' >
                    <h5 className="title">Sign in to your Account</h5>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="text" className="form-control" placeholder='Email' id="email" name="email" 
                            onBlur={form.handleBlurEvent}
                            onChange={form.handleChangeEvent}
                            value={fields.email}/>
                        </div>
                        <label className="errorc" >{errors.email? errors.email: ""}</label>
                    </div>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="password" className="form-control" placeholder='Password' id="password" name="password" 
                              onBlur={form.handleBlurEvent}
                              onChange={form.handleChangeEvent}
                              value={fields.password}
                            />
                        </div>
                        <label className="errorc">{errors.password? errors.password: ""}</label>
                    </div>
                    <div className="col-lg-12">
                        <button className="btn btn-raised btn-primary waves-effect" type="submit">SIGN IN</button>
                        &nbsp;
                        &nbsp;
                        <Link to="/sign-up" className="btn btn-raised btn-info waves-effect" type="submit">SIGN UP</Link>
                    </div>
                    <div className="col-lg-12 m-t-20">
                    <Link className="" to="/forgot-password">Forgot Password?</Link>
                    </div>                    
                </form>
            </div>
        </div>
    </div>
</div>
  )
}
